<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        <PatientsCounter
          queueTitle="Autorizações"
          queueType="authorization"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <authorization permissionKey="authorization_queue" can="read">
          <Attendances queueType="authorization" />
        </authorization>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Attendances from "@/components/queues/attendances.vue";
  import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";

  export default {
    name: "AuthorizationQueue",
    components: {
      Attendances,
      PatientsCounter,
    },
  };
</script>

<style lang="scss" scoped></style>
